export const events = {
  USER_SIGNED_IN: 'auth/USER_SIGNED_IN',
  USER_SIGNED_OUT: 'auth/USER_SIGNED_OUT',
  AUTH_STATE_CHANGED: 'auth/AUTH_STATE_CHANGED'
};